import React, { Component } from 'react'
import { Menu, Input } from 'antd'
import { connect } from 'react-redux'
import { getMetrics } from '../selectors'
import R from 'ramda'
import { fromNullable } from 'data.maybe'
import { trendElements } from './trend-spec'
import { withRouter } from 'react-router'

const specToLink = props => (
  <Menu.Item style={{ margin: '0px' }} exact key={`${'/trend/detail'}/${props.id}`}>
    {props.display}
  </Menu.Item>
  // <MenuItem key={`${props.id}-${props.group}`} prefix="/trend/detail" {...props} />
)

class TrendMenu extends Component {
  filterChanged = e => this.setState({ filterText: e.target.value })
  setSelectedKeys = selectedKeys => this.setState({ selectedKeys })

  render() {
    const { filterText, selectedKeys } = this.state || {}
    const { style, metrics } = this.props
    const createMenus = R.compose(
      R.sortBy(a => a.display),
      R.filter(v => v),
      R.map(id => metrics[id])
    )
    const menus = createMenus(trendElements)
    const menuSelected = ({ key }) => {
      this.setSelectedKeys(key)
      //
      const { history } = this.props
      const location = { pathname: `${key}` }
      history.push(location)
    }

    const matchFilter = str =>
      fromNullable(filterText)
        .map(t => t.toLowerCase())
        .map(t => str.toLowerCase().includes(t))
        .getOrElse(true)

    return (
      <Menu
        selectedKeys={[selectedKeys]}
        // onSelect={({ key }) => this.setSelectedKeys(key)}
        onClick={menuSelected}
        style={{ ...style, height: '100%', width: '30%' }}
        theme="dark"
        mode="inline"
      >
        <Menu.Item>
          <Input
            icon="filter"
            placeholder="Filter..."
            value={filterText}
            onChange={this.filterChanged}
          />
        </Menu.Item>

        {menus.filter(spec => matchFilter(spec.id) || matchFilter(spec.display)).map(specToLink)}
      </Menu>
    )
  }
}

const mapStateToProps = state => ({
  metrics: getMetrics(state),
})

export default withRouter(connect(mapStateToProps)(TrendMenu))
